import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable()
export class FormService {

  constructor() { }

  /**
   * Polyfill for `FormGroup.markAllAsTouched`.
   *
   * TODO: Remove when app is updated to an Angular version with this method implemented.
   */
  markAllAsTouched(formGroup: FormGroup): void {
    for (const control of Object.values(formGroup.controls)) {
      control.markAsTouched();
    }
  }

}
